import type { ReactNode } from 'react'

import dynamic from 'next/dynamic'

import type { LinkProps } from '~/components/links'
import { isProd } from '~/flags'
import { toURL } from '~/utils/urlResolver'

export const serializers = {
  textImageBanner: dynamic(() => import('./TextImageBanner/TextImageBanner')),
  reportTeamModule: dynamic(() => import('./TeamModule/TeamModule')),
  introByPerson: dynamic(() => import('./IntroByPerson/IntroByPerson')),
  quoteByPerson: dynamic(() => import('./QuoteByPerson/QuoteByPerson')),
  reportSectionIntro: dynamic(
    () => import('./ReportSectionIntro/ReportSectionIntro')
  ),
  reportArtistIntro: dynamic(() => import('./ArtistIntro/ArtistIntro')),
  reportTextMultiGrid: dynamic(() => import('./TextMultiGrid/TextMultiGrid')),
  reportEditorialDualColumn: dynamic(
    () => import('./EditorialDualColumn/EditorialDualColumn')
  ),
  reportStats: dynamic(() => import('./ReportStats/ReportStats')),
  reportImageSlider: dynamic(
    () => import('./ReportImageSlider/ReportImageSlider')
  ),
  reportReturnsTable: dynamic(
    () => import('./ReportReturnsTable/ReportReturnsTable')
  ),
  advert: dynamic(() => import('./Advert/Advert')),
  reportLoginGate: dynamic(() => import('./ReportLoginGate/ReportLoginGate')),
  chartEmbed: dynamic(
    () => import('~/components/blocks/MetabaseEmbed/MetabaseEmbed')
  ),
  reportArtworkTable: dynamic(
    () => import('./ReportArtworkTable/ReportArtworkTable')
  ),
} as const

export const components = Object.keys(serializers)

export function resolveBlock(
  block: string | any,
  key?: number,
  hasAdvert?: null | any
): string | ReactNode {
  if (!block || typeof block === 'string') return block
  if (Array.isArray(block))
    return block.map((item, x) => resolveBlock(item, x, hasAdvert))
  if (!block._type) return <div></div>

  if (components.includes(block._type)) {
    const Component = serializers[block._type as keyof typeof serializers]

    return (
      <Component key={block._key || key} {...block} hasAdvert={hasAdvert}>
        {resolveBlock(
          block.children_ || block.children,
          block._key || key,
          hasAdvert
        )}
      </Component>
    )
  }

  if (isProd) return <div></div>

  return <div>{JSON.stringify(block)}</div>
}

export function resolveLink(
  data: Pick<LinkProps, 'internalLink' | 'externalLink'> | 'string'
) {
  if (typeof data === 'string') {
    if (data.includes('mailto:')) return data
    return data
  } else {
    if (data.externalLink) return data.externalLink
    if (data.internalLink) return toURL(data.internalLink.url)
  }

  return ''
}
